module.exports = __webpack_public_path__ + "static/banner-adbbfcc5b4ad0e151b392a9dd322d0d6.jpg";